var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14423",
    "data-name": "Group 14423",
    transform: "translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo--discord",
    transform: "translate(34.569 34.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M14.981,14.911a2.678,2.678,0,1,0,2.452,2.669,2.562,2.562,0,0,0-2.452-2.669Zm8.776,0a2.678,2.678,0,1,0,2.452,2.669,2.562,2.562,0,0,0-2.452-2.669Z",
    transform: "translate(10.098 12.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M41.772,4H9.554A4.941,4.941,0,0,0,4.625,8.953V41.46a4.941,4.941,0,0,0,4.929,4.953H36.819l-1.274-4.448,3.078,2.861,2.909,2.693L46.7,52.087V8.953A4.941,4.941,0,0,0,41.772,4ZM32.492,35.4s-.866-1.034-1.587-1.948a7.587,7.587,0,0,0,4.352-2.861,13.759,13.759,0,0,1-2.765,1.419,15.825,15.825,0,0,1-3.486,1.034,16.843,16.843,0,0,1-6.227-.024,20.183,20.183,0,0,1-3.534-1.034,14.09,14.09,0,0,1-1.755-.817c-.072-.048-.144-.072-.216-.12a.333.333,0,0,1-.1-.072c-.433-.24-.673-.409-.673-.409a7.478,7.478,0,0,0,4.208,2.837c-.721.914-1.611,2-1.611,2a8.717,8.717,0,0,1-7.333-3.655,32.2,32.2,0,0,1,3.462-14.017A11.89,11.89,0,0,1,21.985,15.2l.24.289a16.22,16.22,0,0,0-6.323,3.15s.529-.289,1.419-.7a18.056,18.056,0,0,1,5.458-1.515,2.368,2.368,0,0,1,.409-.048,20.344,20.344,0,0,1,4.857-.048,19.6,19.6,0,0,1,7.237,2.308,16,16,0,0,0-5.987-3.054l.337-.385a11.89,11.89,0,0,1,6.756,2.525,32.2,32.2,0,0,1,3.462,14.017A8.789,8.789,0,0,1,32.492,35.4Z",
    transform: "translate(3.768 3.237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17858",
    "data-name": "Rectangle 17858",
    width: 64,
    height: 64,
    transform: "translate(32 32)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.7e5e50a4.svg";
export { ForwardRef as ReactComponent };